import * as $ from "jquery";

namespace PFF.controllers.sitemap {
	function setupSitemap() {

	}


	export function init() {
		setupSitemap();
	}
}

PFF.controllers.sitemap.init();



// WEBPACK FOOTER //
// ./js/PFF/controllers/sitemap.ts